
/**
 * [convertWeight Converts weight from one metric to another]
 * @param  {String} from
 * @param  {String} to
 * @param  {float} value
 * @return {Float}
*/

const convert = require('convert-units');

const system = {
  ton: 'mt',
  t: 'mt',
}

function convertWeight(from, to, value) {
  const systemFrom = system[from] || from;
  const systemTo = system[to] || to;
  return convert(value).from(systemFrom).to(systemTo);
}

module.exports = convertWeight;
